// @flow

import React from 'react';
import styles from './tabView.scss';
import tabViewList from './tabViewHelper';

type Props = {
  data: Array<any>,
  onTabSelect: Function,
  selectedTab: number,
  tabViewContainerClassName?: string,
  tabClassName?: string,
  selectedTabClassName?: string,
  disabled?: Boolean
};

const TabView = ({
  data = tabViewList.FTM,
  onTabSelect,
  selectedTab,
  tabViewContainerClassName,
  tabClassName,
  selectedTabClassName,
  tabCountClassName,
  tabNameClassName,
  disabled
}: Props) => (
  <div
    className={`${styles.tabView} ${styles[tabViewContainerClassName]} l-row a-center`}
  >
    {data.map((tab, i) => (
      <div
        key={tab.key}
        className={`
          ${`${styles.tab} ${styles[tabClassName]}`}
          ${
            i === selectedTab
              ? `${styles.selected} ${styles[selectedTabClassName]}`
              : ''
          }
          ${disabled ? styles.disabled : ''}
          l-row a-center j-center ${data.length > 1 ? 'flex-50' : 'flex-100'}
        `}
        onClick={() => onTabSelect(i)}
      >
        {tab.count ? (
          <div
            className={`${styles.tabCount} ${styles[tabCountClassName]} l-row j-center`}
          >
            {tab.count}
          </div>
        ) : (
          ''
        )}
        <div
          className={`${styles.tabCount} ${styles[tabNameClassName]} l-row j-center`}
        >
          {tab.name}
        </div>
      </div>
    ))}
  </div>
);
export default TabView;

TabView.defaultProps = {
  tabViewContainerClassName: null,
  tabClassName: null,
  selectedTabClassName: null,
  tabNameClassName: null,
  tabCountClassName: null,
  disabled: false
};
